import { Modal } from "@msys/ui";
import { useTranslate } from "@tolgee/react";
import React from "react";
import { OrganisationMemberSelect } from "./OrganisationMemberSelect.js";

interface Props {
  title: string;
  handleClose: () => void;
  handleComplete: (userId: string, handleClose: () => void) => void;
  sorting?: React.ComponentProps<typeof OrganisationMemberSelect>["sorting"];
  filters?: React.ComponentProps<typeof OrganisationMemberSelect>["filters"];
}

export const OrganisationMemberSelectModal = ({
  title,
  handleClose,
  handleComplete,
  sorting,
  filters,
}: Props) => {
  const { t } = useTranslate(["Global"]);
  const [selectedMember, setSelectedMember] = React.useState<string | null>(
    null
  );

  return (
    <Modal
      title={title}
      handleClose={handleClose}
      actionButtons={[
        {
          label: t("Cancel", { ns: "Global" }),
          handleClick: handleClose,
          buttonProps: { variant: "text" },
        },
        {
          label: t("Confirm", { ns: "Global" }),
          handleClick: () => {
            if (!selectedMember) throw new Error("No member selected");
            handleComplete(selectedMember, handleClose);
          },
          buttonProps: { disabled: !selectedMember },
        },
      ]}
    >
      <OrganisationMemberSelect
        value={selectedMember}
        onChange={setSelectedMember}
        inputLabel={t("Contact", { ns: "Global" })}
        sorting={sorting}
        filters={filters}
      />
    </Modal>
  );
};
